import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  standalone: false,
})
export class ErrorPageComponent {
  private route = inject(ActivatedRoute);

  public title: string;
  public message: string;
  public code: string | undefined;

  constructor() {
    this.route.data.subscribe((data) => {
      this.title = data.title ?? '';
      this.message = data.message ?? '';
      this.code = data.code;
    });
  }
}
